import { Box, Button, CircularProgress } from '@mui/material';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Navigate } from 'react-router-dom';

import { FleetPicker } from './FleetPicker';
import { useGetFleetsQuery } from '../../../../api/fleet-verification';
import type { FleetRef } from '../../../../domain/fleet-verification';
import { StoreInfoSecurelyNote } from '../../../../general/components/store-info-securely-note';
import { TerminalWizardPage } from '../../../../general/components/wizard-page';
import { LockIcon } from '../../../../general/icons';
import { NO_MATCHING_FLEET } from '../../../../paths';
import { startOrResumeApplication } from '../../reducers';

function FleetSelectionPage() {
  const { data, isFetching } = useGetFleetsQuery(undefined, { refetchOnMountOrArgChange: true });
  const fleets = data ?? [];

  if (isFetching) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  } else if (fleets.length === 0) {
    return <Navigate to={NO_MATCHING_FLEET} replace />;
  } else if (fleets.length === 1) {
    // TODO: Replace with redirection to the relevant page once ready.
    return <div>Redirect to application creation / business info</div>;
  } else {
    return <FleetSelectionPageContent fleets={fleets} />;
  }
}

type FleetSelectionPageContentProps = {
  fleets: FleetRef[];
};

function FleetSelectionPageContent({ fleets }: FleetSelectionPageContentProps) {
  const dispatch = useDispatch();

  const [selectedFleetId, setSelectedFleetId] = useState<string>(fleets[0].id);

  const handleClick = () => dispatch(startOrResumeApplication({ fleetId: selectedFleetId }));

  return (
    <TerminalWizardPage title="Select your company" subtext="Which company would you like to verify?">
      <FleetPicker value={selectedFleetId} options={fleets} onChange={setSelectedFleetId} />
      <Button fullWidth onClick={handleClick} startIcon={<LockIcon />} sx={{ mt: 2 }} size="large" variant="contained">
        Next
      </Button>
      <StoreInfoSecurelyNote sx={{ mt: 4 }} />
    </TerminalWizardPage>
  );
}

export { FleetSelectionPage, FleetSelectionPageContent, type FleetSelectionPageContentProps };
